export const chooseReasonInfo_zh =
    [
        {
            title: '信任',
            detail: '我们将信任视为业务关系的核心，通过与客户、合作伙伴和员工的透明沟通和一致行动来不断加强这种信任。我们相信，持久的信任是成功合作和长期关系的基础。',
            path: 'heart', //
        },
        {
            title: '责任',
            detail: '在提供决策支持和战略咨询时，我们全面负责其社会和商业影响。通过负责任的咨询实践，我们确保客户在道德和法律框架内运营，同时帮助他们实现可持续性目标。',
            path: 'resp',
        },
        {
            title: "专业精神",
            detail: '我们致力于在所有专业领域追求卓越。通过推动持续教育并实施行业最佳实践，我们确保我们的团队在战略、风险管理和市场分析方面拥有无与伦比的专业知识和技能。',
            path: 'prof',
        },
        {
            title: "可靠",
            detail: 'WIT咨询致力于成为客户最信赖的顾问，准确、及时地履行我们的承诺。我们确保每个项目都达到高质量标准，赢得客户的长期信任和信心。',
            path: 'reliable',
        },
        {
            title: "团队合作",
            detail: '我们重视团队合作，鼓励跨学科合作，并培养创新思维。通过整合来自各领域的专业知识和观点，我们为客户提供全面且富有洞察力的解决方案，以有效应对复杂问题。',
            path: 'teamwork',
        },
        {
            title: "严格保密性",
            detail: '我们在处理所有客户信息和数据时，坚持最严格的保密原则。通过实施先进的安全措施并遵循行业保密标准，我们确保客户信息免受任何威胁，保护其利益和信任。',
            path: 'sc',
        }
    ]

